/**
 * Validates if the input is a Valid Text
 * Non null, non undefined, non empty
 * @param text The Text to be validated
 * @returns {*} the Text if it is Valid
 * @thro
 */
function validateText(text) {
  if (typeof text === "undefined") throw new Error("text can't be undefined");
  if (text === null) throw new Error("text can't be null");
  if (text === "") throw new Error("text can't be an empty string");
  return text;
}

export default {
  validateText: validateText,
  debug: function debug(msg) {
    if (!window.DEBUG_FLUX_STATE) return;

    for (var _len = arguments.length, obj = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      obj[_key - 1] = arguments[_key];
    }

    if (obj) console.log(msg, obj);else console.log(msg);
  },
  log: function log(msg) {
    for (var _len2 = arguments.length, obj = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      obj[_key2 - 1] = arguments[_key2];
    }

    if (obj) console.log(msg, obj);else console.log(msg);
  }
};